/**
 * Simple function to return a ObjectId-like string
 * https://stackoverflow.com/a/37438675
 */
export const getPseudoObjectId = (m = Math, d = Date, h = 16, s = (s: number) => m.floor(s).toString(h)) =>
  s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h));
